import ACTIONS from '~shared/actions';
import { PackageIds } from '~shared/constants/pricing';
import { CombinedActions } from '~shared/types/pricing/actions';

const determinePackageSwap = (
  numberOfUsers: string,
  isAdvantagePackage: boolean,
  isPremierPackage: boolean,
  dispatch: React.Dispatch<CombinedActions>
): void => {
  let packageSwap = {};

  if (isAdvantagePackage) {
    if (Number(numberOfUsers) > 1) {
      packageSwap = {
        packageToBeReplaced: PackageIds.ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.TEAM_ADVANTAGE_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.ADVANTAGE_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }

  if (isPremierPackage) {
    if (Number(numberOfUsers) > 1) {
      packageSwap = {
        packageToBeReplaced: PackageIds.PREMIER_ANNUAL,
        replacedWith: PackageIds.TEAM_PREMIER_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_PREMIER_ANNUAL,
        replacedWith: PackageIds.PREMIER_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }
};

export default determinePackageSwap;
